<template>
  <div
    @blur="outOfFocus($event)"
    @focusout="outOfFocus($event)"
    class="select-page-menu"
    ref="selectPageMenu"
    @keydown.escape.stop="closeMenu"
    @keydown="handleKeydown"
  >
    <button tabindex="0" class="select-page-menu-button" @click="actionOne">{{$t('cci_nav_bar_select_left_page_title')}}</button>
    <button tabindex="0" class="select-page-menu-button" @click="actionTwo">{{$t('cci_nav_bar_select_right_page_title')}}</button>
  </div>
</template>

<script>
export default {
  props: {
    buttonRef: {
      type: HTMLButtonElement,
      required: true
    }
  },
  mounted() {
    this.positionDialogMenu();
  },
  methods: {
    positionDialogMenu() {
      const button = this.buttonRef;
      const menu = this.$refs.selectPageMenu;
      if (button && menu) {
        const buttonRect = button.getBoundingClientRect();
        const menuRect = menu.getBoundingClientRect();
        menu.style.top = `${buttonRect.bottom + window.scrollY}px`;
        menu.style.left = `${buttonRect.left - menuRect.width + window.scrollX}px`;
        // Focus the first button
        menu.children[0].focus();
      }
    },
    actionOne() {
      this.$emit('action-one');
    },
    actionTwo() {
      this.$emit('action-two');
    },
    outOfFocus(event) {
      if (event.relatedTarget && event.relatedTarget.className === 'select-page-menu-button') {
        return;
      }
      this.$emit('out-of-focus');
    },
    closeMenu() {
      this.$emit('close-menu');
    },
    handleKeydown(event) {
      const buttons = this.$refs.selectPageMenu.querySelectorAll('.select-page-menu-button');
      const currentIndex = Array.from(buttons).indexOf(document.activeElement);

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % buttons.length;
        buttons[nextIndex].focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        const prevIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        buttons[prevIndex].focus();
      }
    }
  }
};
</script>

<style lang="scss">
@import 'helpers/_colors-and-mixins.scss';
@import 'bourbon';

.select-page-menu {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 4px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  border-radius: 4px;
}

.select-page-menu-button {
  padding-top: 3px;
  padding-bottom: 3px;
  font-family: 'Open Sans Bold', sans-serif;
  font-weight: 700;
  color: $wet-asphalt;
  text-align: left;
}

.select-page-menu-button:hover {
  background-color: rgba(128, 128, 128, 0.18);
}
</style>